/**
 * Wholesale Gorilla Cart - Terms & Conditions Checkbox Handler
 * This script manages the T&C checkbox visibility and checkout button state
 */
(function () {
  "use strict";

  // Check if we're on the ws-cart page
  function isWsgCartPage() {
    return window.location.pathname.includes("/pages/ws-cart");
  }

  // Get current step from URL
  function getCurrentStep() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("step");
  }

  // Handle T&C checkbox visibility and checkout button state
  function handleWsgTermsCheckbox() {
    const tcContainer = document.querySelector(".wsg-ws-cart-tc");
    const tcCheckbox = document.getElementById("tc-ws");
    const checkoutBtn = document.getElementById("wsg-checkout-two");

    if (!tcContainer) return;

    const currentStep = getCurrentStep();

    if (currentStep === "2") {
      // Show T&C checkbox on step 2
      tcContainer.style.display = "block";

      // Disable checkout button initially if it exists
      if (checkoutBtn) {
        checkoutBtn.disabled = true;
        checkoutBtn.style.opacity = "0.5";
        checkoutBtn.style.cursor = "not-allowed";
      }

      // Handle checkbox change
      if (tcCheckbox) {
        tcCheckbox.addEventListener("change", function () {
          if (checkoutBtn) {
            checkoutBtn.disabled = !this.checked;
            checkoutBtn.style.opacity = this.checked ? "1" : "0.5";
            checkoutBtn.style.cursor = this.checked ? "pointer" : "not-allowed";
          }
        });
      }
    } else {
      // Hide T&C checkbox on other steps
      tcContainer.style.display = "none";
    }
  }

  // Initialize when content is loaded
  function init() {
    if (!isWsgCartPage()) return;

    // Check immediately
    handleWsgTermsCheckbox();

    // Also check after a short delay to account for dynamic content loading
    setTimeout(handleWsgTermsCheckbox, 500);
    setTimeout(handleWsgTermsCheckbox, 1000);

    // Watch for URL changes (for single-page app behavior)
    let lastUrl = location.href;
    new MutationObserver(() => {
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        handleWsgTermsCheckbox();
      }
    }).observe(document, { subtree: true, childList: true });
  }

  // Run on DOMContentLoaded
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Also run on window load as fallback
  window.addEventListener("load", handleWsgTermsCheckbox);
})();
